import type { VideoListItem } from '@ayub/shared'
import { formatNumber, formatSom } from '@ayub/shared'
import { cn } from '@/lib/utils'
import { VIDEO_STAGE_META } from './stageMeta'
import { linkVerifyUrgency, videoCardStatus, VIDEO_URGENCY_META } from './urgency'

interface VideoKanbanCardProps {
  video: VideoListItem
  onClick: (id: number) => void
}

/**
 * Kanban kartochkasi — `docs/04-ui-ux.md` "Kanban kartochkasi" uslubiga mos: chap chetida
 * 3px rangli chiziq (BOSQICH rangi), ~88px balandlik, sarlavha 14/600, qolgani hint rangda.
 *
 * Video kanbanida drag&drop yo'q (bloger kanbanidan farqli): deyarli barcha bosqich
 * o'tishlari avtomatik (cron: 15/30-kun tekshiruv, oylik to'lov) yoki moderatsiya kartochkasi
 * ichidagi qaror (Tasdiqlash/Rad etish, sabab talab qiladi) orqali sodir bo'ladi — qo'lda
 * ustundan-ustunga sudrash uchun haqiqiy backend amali yo'q, shuning uchun kartochka oddiy
 * bosiladigan tugma sifatida qurilgan.
 */
export function VideoKanbanCard({ video, onClick }: VideoKanbanCardProps) {
  const stageMeta = VIDEO_STAGE_META[video.stage]
  const status = videoCardStatus(video)
  const urgencyMeta = VIDEO_URGENCY_META[video.urgency]

  // `video.urgency` (server) FAQAT `CHECKING` bosqichida hisoblanadi — `POSTED` bosqichidagi
  // tekshirilmagan havolani QAMRAB OLMAYDI. Nuqta shu ikkalasining BIRLASHMASI: tekshiruv
  // muddati bo'yicha shoshilinch (`video.urgency`) YOKI havola SLA'si bo'yicha shoshilinch
  // (`linkVerifyUrgency`) — 48 soatdan oshgani qizil, oshmagani amber (Bosqich 8 talabi).
  const linkUrgency = linkVerifyUrgency(video)
  const dotClass =
    video.urgency !== 'none'
      ? urgencyMeta.dotClass
      : linkUrgency !== null
        ? VIDEO_URGENCY_META[linkUrgency === 'overdue' ? 'overdue' : 'today'].dotClass
        : null

  return (
    <button
      type="button"
      onClick={() => onClick(video.id)}
      className={cn(
        'flex min-h-[88px] w-full flex-col justify-center gap-1 rounded-card border-l-[3px] bg-app-card p-3 text-left shadow-[0_1px_3px_rgba(0,0,0,.06)] transition-all duration-150 ease-out hover:-translate-y-0.5 hover:shadow-[0_4px_10px_rgba(0,0,0,.08)] dark:shadow-none',
        stageMeta.borderClass,
      )}
    >
      <span className="flex items-center gap-1.5 text-sm font-semibold text-app-text">
        {dotClass && (
          <span className={cn('size-1.5 shrink-0 rounded-full', dotClass)} aria-hidden="true" />
        )}
        <span className="truncate">@{video.blogger.instagramUsername}</span>
      </span>
      <span className="truncate text-xs text-app-hint">{video.blogger.fullName}</span>
      <span className={cn('truncate text-xs font-medium', status.toneClass)}>{status.text}</span>
      {video.views !== null && (
        <span className="tabular text-xs font-semibold text-brand">
          {formatNumber(video.views)}
          {video.amount !== null ? ` · ${formatSom(video.amount)}` : ''}
        </span>
      )}
    </button>
  )
}
